import clientRequestService from "../../../services/ClientRequestService";
export const getURlDownloadFileService = async (url: string) => {
  return await clientRequestService({
    method: "get",
    url,
  });
};
